//////////////////////////////////////////////////////////////

import type { TAVRValveMetadata } from './TAVRDevices';
import { DeviceWithMetadata } from '@/engine/PlanningAlgorithm/DataTypes';

export * from '../common/CardiacDataTypes';

//////////////////////////////////////////////////////////////

export class TAVRValveDevice extends DeviceWithMetadata<TAVRValveMetadata>('DT.TAVRValveDevice', 'Valve') {}
